import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-l pb-xs border-gray-200 border-b-2 flex items-center justify-between" }
const _hoisted_2 = { class: "mb-s" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import RoundedCard from "@/components/RoundedCard.vue";
import { Profile } from "@/interfaces/profile";
import { computed, ref, onMounted } from "vue";
import { usePublicStore } from "@/store/publicStore";
import { useSessionStore } from "@/store/sessionStore";
import { useAccountStore } from "@/store/accountStore";
import UmanaHeadline from "@/components/UmanaHeadline.vue";
import { supabase } from "@/helpers/supabase";
import IconButton from "@/components/IconButton.vue";
import DialogCard from "@/components/DialogCard.vue";
import { MedicationOrderStatus } from "@/interfaces/enum/medicationOrderStatus";
import CoreIcon from "@/components/CoreIcon.vue";
import { Weekdays } from "@/interfaces/enum/weekdays";

export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyCard',
  props: {
    isOwnerOfSelectedCareProviderGroup: { type: Boolean }
  },
  setup(__props: any) {

const medicationOrderStatus = MedicationOrderStatus;
const publicStore = usePublicStore();
const accountStore = useAccountStore();
const sessionStore = useSessionStore();

const showGroupSettings = ref<boolean>(false);
const showAdditionalSettings = ref<boolean>(false);
const careProviderGroupModel = ref<any>({});

const props = __props;

const shops = computed(() => {
  const availableShops: {
    label: string;
    value: number | null;
  }[] =
    publicStore.careProviderGroups
      ?.filter((cpg) => cpg.is_shop)
      .map((cpg) => ({ label: cpg.group_name, value: cpg.id })) ?? [];

  availableShops.unshift({ label: "Keine Apotheke", value: null });

  return availableShops;
});

const ownerOfSelectedCareProviderGroup = computed(() =>
  (publicStore.profiles ?? []).find(
    (profile) => profile.id == sessionStore.selectedCareProviderGroup?.owner
  )
);

const ownerOfSelectedCareProviderGroupString = computed(() => {
  let owner = ownerOfSelectedCareProviderGroup.value;
  if (owner?.id == sessionStore.session?.user.id) {
    return "Sie";
  } else {
    return `${owner?.first_name} ${owner?.last_name}`;
  }
});

onMounted(() => {
  careProviderGroupModel.value = {
    name: sessionStore.selectedCareProviderGroup?.group_name,
    email: sessionStore.selectedCareProviderGroup?.email,
    shortName: sessionStore.selectedCareProviderGroup?.short_name,
    address1: sessionStore.selectedCareProviderGroup?.address1,
    address2: sessionStore.selectedCareProviderGroup?.address2,
    zip: sessionStore.selectedCareProviderGroup?.zip,
    city: sessionStore.selectedCareProviderGroup?.city,
    isOrderer: sessionStore.selectedCareProviderGroup?.is_orderer,
    isShop: sessionStore.selectedCareProviderGroup?.is_shop,
    medicationStatusAfterScan: MedicationOrderStatus.find(
      (status) =>
        status.id ==
        sessionStore.selectedCareProviderGroup?.medication_status_after_scan
    ),
    ordersDay: buildOrdersDayInput(),
    standardShop: sessionStore.selectedCareProviderGroup?.standard_shop,
  };
});

function buildOrdersDayInput() {
  return sessionStore.selectedCareProviderGroup?.preferred_weekday?.map((wd) =>
    Weekdays.find((w) => w.id == wd)
  );
}

async function saveCareProviderGroup() {
  let profile = await supabase
    .from("careProviderGroup")
    .update([
      {
        group_name: careProviderGroupModel.value.name,
        email: careProviderGroupModel.value.email,
        short_name: careProviderGroupModel.value.shortName,
        address1: careProviderGroupModel.value.address1 ?? "",
        address2: careProviderGroupModel.value.address2 ?? "",
        zip: careProviderGroupModel.value.zip ?? "",
        city: careProviderGroupModel.value.city ?? "",
        is_orderer: careProviderGroupModel.value.isOrderer == true,
        is_shop: careProviderGroupModel.value.isShop == true,
        medication_status_after_scan:
          careProviderGroupModel.value.medicationStatusAfterScan.id ?? 2,
        preferred_weekday: careProviderGroupModel.value.ordersDay?.map(
          (od: any) => od.id
        ),
        standard_shop: careProviderGroupModel.value.standardShop,
      },
    ])
    .eq("id", sessionStore.selectedCareProviderGroup?.id)
    .select()

    .returns<Profile>()
    .single();
  accountStore.setProfile(profile.data);
  showGroupSettings.value = false;
}

return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(RoundedCard, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(UmanaHeadline, { h: "h2" }, {
            default: _withCtx(() => [
              _createTextVNode("Ihr Unternehmen")
            ]),
            _: 1
          }),
          (props.isOwnerOfSelectedCareProviderGroup)
            ? (_openBlock(), _createBlock(IconButton, {
                key: 0,
                icon: "pen",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showGroupSettings.value = true))
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_2, " Administrator des Unternehmens: " + _toDisplayString(ownerOfSelectedCareProviderGroupString.value), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(sessionStore).selectedCareProviderGroup?.group_name ?? ""), 1),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_unref(sessionStore).selectedCareProviderGroup?.address1 ?? ""), 1),
            _hoisted_3,
            _createTextVNode(_toDisplayString(_unref(sessionStore).selectedCareProviderGroup?.zip ?? "") + " " + _toDisplayString(_unref(sessionStore).selectedCareProviderGroup?.city ?? ""), 1),
            _hoisted_4
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(DialogCard, {
      color: "gray",
      "is-visible": showGroupSettings.value,
      "show-footer": false,
      title: "Unternehmenseinstellungen",
      onClose: _cache[3] || (_cache[3] = ($event: any) => (showGroupSettings.value = false))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FormKit, {
          type: "form",
          onSubmit: saveCareProviderGroup,
          modelValue: careProviderGroupModel.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((careProviderGroupModel).value = $event)),
          "submit-label": "Gruppe bearbeiten"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FormKit, {
              required: "",
              type: "text",
              validation: "required",
              name: "name",
              helper: "Name",
              label: "Name"
            }),
            _createVNode(_component_FormKit, {
              required: "",
              type: "text",
              name: "shortName",
              maxlength: "3",
              label: "Kürzel",
              validation: "required"
            }),
            _createVNode(_component_FormKit, {
              type: "text",
              name: "email",
              help: "An diese E-Mail werden Benachrichtigungen gesendet. Leer lassen, wenn keine Benachrichtigungen gewünscht sind.",
              label: "E-Mail"
            }),
            _createVNode(_component_FormKit, {
              required: "",
              type: "text",
              name: "address1",
              label: "Adresse",
              validation: "required"
            }),
            _createVNode(_component_FormKit, {
              type: "text",
              name: "address2",
              label: "2. Adresszeile"
            }),
            _createVNode(_component_FormKit, {
              required: "",
              type: "text",
              name: "zip",
              maxlength: "4",
              label: "PLZ",
              validation: "required"
            }),
            _createVNode(_component_FormKit, {
              required: "",
              type: "text",
              name: "city",
              label: "Stadt",
              validation: "required"
            }),
            _createElementVNode("div", {
              class: "flex justify-between mb-s mt-m",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showAdditionalSettings.value = !showAdditionalSettings.value))
            }, [
              _createVNode(UmanaHeadline, { h: "h3" }, {
                default: _withCtx(() => [
                  _createTextVNode("Erweiterte Einstellungen")
                ]),
                _: 1
              }),
              _createVNode(CoreIcon, {
                icon: "fold",
                class: _normalizeClass(["transition-transform", { 'rotate-180': showAdditionalSettings.value }])
              }, null, 8, ["class"])
            ]),
            _withDirectives(_createVNode(_component_FormKit, {
              type: "multiselect",
              "allow-empty": false,
              selectOptions: _unref(medicationOrderStatus),
              "option-label": "name",
              name: "medicationStatusAfterScan",
              "divack-by": "id",
              label: "Status nach Kistenzuordnung",
              placeholder: "Status wählen",
              help: "Welchen Status sollen Produkte erhalten, nachdem Sie via Scanner einer Kiste zugeordnet wurden?"
            }, null, 8, ["selectOptions"]), [
              [_vShow, careProviderGroupModel.value.isShop && showAdditionalSettings.value]
            ]),
            _withDirectives(_createVNode(_component_FormKit, {
              type: "checkbox",
              name: "isOrderer",
              maxlength: "4",
              label: "Bestellt Medikamente",
              help: "Das Unternehmen bestellt Medikamente bei einem anderen Unternehmen"
            }, null, 512), [
              [_vShow, showAdditionalSettings.value]
            ]),
            _withDirectives(_createVNode(_component_FormKit, {
              type: "checkbox",
              name: "isShop",
              maxlength: "4",
              label: "Liefert Medikamente",
              help: "Das Unternehmen liefert Medikamente an ein anderes Unternehmen"
            }, null, 512), [
              [_vShow, showAdditionalSettings.value]
            ]),
            _withDirectives(_createVNode(_component_FormKit, {
              type: "multiselect",
              "option-label": "name",
              name: "ordersDay",
              "track-by": "id",
              multiple: true,
              allowEmpty: true,
              selectOptions: _unref(Weekdays),
              label: "Bestelltage",
              placeholder: "Bestelltage wählen",
              help: "An welchen Wochentagen erwarten Sie normalerweise Ihre Bestellungen?"
            }, null, 8, ["selectOptions"]), [
              [_vShow, careProviderGroupModel.value.isOrderer && showAdditionalSettings.value]
            ]),
            _withDirectives(_createVNode(_component_FormKit, {
              type: "select",
              name: "standardShop",
              id: "standardShop",
              options: shops.value,
              allowEmpty: true,
              label: "Standard Apotheke",
              placeholder: "Apotheke wählen",
              help: "Von welcher Apotheke bestellen Sie normalerweise Ihre Medikamente."
            }, null, 8, ["options"]), [
              [_vShow, careProviderGroupModel.value.isOrderer && showAdditionalSettings.value]
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["is-visible"])
  ], 64))
}
}

})